import CountryPageTemplate from './CountryPageTemplate';

export default function RomaniaPage() {
  return <CountryPageTemplate countryKey="ro" />;
}